import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/500.svg")